var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"section"},[_c('div',{staticClass:"content has-text-grey has-text-centered"},[_c('p',[_c('b-icon',{attrs:{"icon":_vm.smile ? 'emoticon' : 'emoticon-sad',"size":"is-large"}})],1),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('fields.empty')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }